import { render } from "./PartContacts.vue?vue&type=template&id=06f8aa15"
import script from "./PartContacts.vue?vue&type=script&lang=js"
export * from "./PartContacts.vue?vue&type=script&lang=js"

import "./PartContacts.vue?vue&type=style&index=0&id=06f8aa15&lang=sass"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__